import { DropLocation } from '~/lib/api/smartsend/types';

export const ItemPickupLocationCache: { [key: string]: DropLocation } = {};
